import { useTranslation } from 'react-i18next'
import { Button, H3, Text } from '@/components/atoms'
import { BenefitCard } from '@/components/molecules'
import wellfold from '@/shared/assets/images/onboarding/wellfold.png'
import wellfoldMobile from '@/shared/assets/images/onboarding/wellfold-mobile.png'

interface RentersStepFourPageProps {
  onContinue: () => void
  onBack: () => void
}

export function RentersStepFourPage({
  onContinue,
  onBack,
}: RentersStepFourPageProps) {
  const { t } = useTranslation()

  return (
    <div className="flex h-full flex-col">
      <div className="min-h-0 flex-1 overflow-y-auto pb-4 md:h-full md:pb-0">
        <div className="flex w-full flex-col gap-4 md:h-full md:flex-row md:justify-between md:gap-6">
          <div className="flex flex-col gap-4 md:max-w-89.5 md:justify-between md:gap-6">
            <div className="flex flex-col gap-4 md:gap-6">
              <H3 className="text-neutral-900">
                {t('onboarding.renters.stepFour.title')}
              </H3>
              <Text className="text-sm text-neutral-900 md:text-base">
                {t('onboarding.renters.stepFour.description')}
              </Text>
            </div>
            <div className="hidden gap-3 md:mb-2.5 md:flex">
              <Button
                variant="secondary"
                onClick={onBack}
                className="h-12"
                data-testid="step-four-back"
              >
                {t('onboarding.back')}
              </Button>
              <Button
                onClick={onContinue}
                className="h-12"
                data-testid="step-four-continue"
              >
                {t('onboarding.continue')}
              </Button>
            </div>
          </div>
          <BenefitCard
            image={
              <img
                src={wellfold}
                alt={t('onboarding.renters.stepFour.benefitName')}
                className="h-full w-full object-cover"
              />
            }
            imageContainerSize="h-[175.114px] w-[220.25px] shrink-0 self-start"
            variant="vertical"
            title={t('onboarding.renters.stepFour.benefitName')}
            description={t('onboarding.renters.stepFour.benefitDescription')}
            className="hidden max-w-99.5 self-start md:flex"
          />
          <BenefitCard
            image={
              <img
                src={wellfoldMobile}
                alt={t('onboarding.renters.stepFour.benefitName')}
                className="h-full w-full object-cover"
              />
            }
            imageContainerSize="w-full aspect-[115/62]"
            variant="vertical"
            title={t('onboarding.renters.stepFour.benefitName')}
            description={t('onboarding.renters.stepFour.benefitDescription')}
            className="md:hidden"
          />
        </div>
      </div>

      <div className="flex w-full gap-3 pt-4 md:hidden">
        <Button
          variant="secondary"
          onClick={onBack}
          className="h-12 w-full"
          data-testid="step-four-back"
        >
          {t('onboarding.back')}
        </Button>
        <Button
          onClick={onContinue}
          className="h-12 w-full"
          data-testid="step-four-continue"
        >
          {t('onboarding.continue')}
        </Button>
      </div>
    </div>
  )
}
